import { HttpErrorResponse } from "@angular/common/http";

import { FlowToken } from "@venecia/apis/auth";

export class BearerUtil {
    static isValid(token: FlowToken | null): boolean {
        return token !== null
            && typeof token['expires-at'] === 'string'
            && !this.expired(token['expires-at'])
            && typeof token['access-token'] === 'string'
            && token['access-token'].length > 0;
    }

    /**
     * Checks whether an ISO-8601 date with offset is still valid.
     * The comparison is done in UTC.
     *
     * @param expiresAt ISO-8601 date string (e.g. 2026-01-31T23:32:50+01:00)
     * @returns true if the token is still valid, false if expired
     */
    static expired(expiresAt: string): boolean {
        const expiresAtMs: number = Date.parse(expiresAt);
        if (Number.isNaN(expiresAtMs)) {
            return true;
        }
        const nowMs: number = Date.now();
        const slackMs: number = 60_000;
        return nowMs >= (expiresAtMs - slackMs);
    }

    static throwHttpError(): void {
        const err: HttpErrorResponse = new HttpErrorResponse({
            status: 500,
            error: {
                status: 500,
                error: true,
                body: {
                    code: 'err.infra.token.001',
                    message: 'Token service returned an invalid response.'
                }
            }
        });
        throw err;
    }
}